module.exports = __webpack_public_path__ + "8ee55c2152eb11e1770f9c0f71720579.pdf";